'use client';

import { useState } from 'react';

import { Waypoint } from 'react-waypoint';

function InView({ children, ...props }: Waypoint.WaypointProps) {
	// States
	const [isVisible, setIsVisible] = useState(false);

	// Functions
	function handleEnter(args: Waypoint.CallbackArgs) {
		setIsVisible(true);
		props.onEnter?.(args);
	}

	return (
		<Waypoint {...props} onEnter={handleEnter}>
			<div>{isVisible ? children : null}</div>
		</Waypoint>
	);
}

export default InView;
